export const fontWeight = {
  fontWeight: {
    fontWeightNormal: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
  },
};
